module.exports = __webpack_public_path__ + "media/images/tailwind/arrow-left-2e0707ccdede6ed2d586d7d2cfc91269.png";